import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getUserById, connectUsers } from "../api/api";
import { environment } from "../../environments/environments";
import {
  CCard,
  CCardBody,
  CCardHeader,
  CCardImage,
  CCardFooter,
} from "@coreui/react";
import "../MemberProfile/MemberProfile.css";
import Swal from "sweetalert2";
const MemberProfile = () => {
  const { memberId } = useParams();
  const navigate = useNavigate();
  const [memberData, setMemberData] = useState(null);
  const [currentUserData, setCurrentUserData] = useState(null);
  const [isRequestSent, setIsRequestSent] = useState(false);
  const [isRequestReceived, setIsRequestReceived] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [imageUrl, setImageUrl] = useState("");

  // ✅ Fetch Member Data
  useEffect(() => {
    const fetchMemberData = async () => {
      try {
        const response = await getUserById({ user_id: memberId });
        console.log("member_Response", response.data);
        setMemberData(response.data);

        // ✅ Dynamic Image URL Setup
        const moreImages = response.data.more_images;
        setImageUrl(
          moreImages?.length
            ? `${environment.url}uploads/users/${moreImages[0]}`
            : response.data.image
        );
        console.log("imageurl", imageUrl);
      } catch (error) {
        console.error("Error fetching member data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    if (memberId) fetchMemberData();
  }, [memberId]);

  // ✅ Fetch Current User Data
  useEffect(() => {
    const fetchCurrentUserData = async () => {
      const userDatass = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userDatass);
      //   setcurrUser(parsedUserData);
      const _curid = parsedUserData?.id || parsedUserData?._id;
      console.log("-_curid", _curid);
      try {
        const response = await getUserById({ user_id: _curid });
        setCurrentUserData(response.data);

        const interestsSent = new Set(response.data.interests_sent || []);
        const interestsReceived = new Set(
          response.data.interests_received || []
        );

        setIsRequestSent(interestsSent.has(memberId));
        setIsRequestReceived(interestsReceived.has(memberId));
      } catch (error) {
        console.error("Error fetching current user data:", error);
      }
    };

    fetchCurrentUserData();
  }, [memberId]);

  // ✅ Send Interest
  const handleSendInterest = async () => {
    try {
      const userData = localStorage.getItem("currentUser");
      const parsedUserData = JSON.parse(userData);
      const _id = parsedUserData?.id || parsedUserData?._id;
      const values = {
        user_id: _id,
        match_confirm_user_id: memberId,
      };
      console.log("valueeeSend333333333333333", values);
      const response = await connectUsers(values);
      if (response.success) {
        // alert(response.message);
        // setIsRequestSent(true);
        Swal.fire({
          icon: "success",
          title: "Interest Sent!",
          text: response.message,
          confirmButtonText: "Okay",
        });
        setIsRequestSent(true);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed to Send Interest",
          text: response.message,
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      console.error("Error sending interest:", error);
    }
  };

  if (isLoading)
    return (
      <div className="loadingDiv">
        <p className="loadingtext">Loading...</p>
      </div>
    );

  return (
    <div className="member-profile-container">
      <CCard className="memberprofile-card">
        <CCardHeader className="memberprofile-header">
          {memberData.name}'s Profile
        </CCardHeader>
        <CCardBody className="profile-body">
          {imageUrl ? (
            <CCardImage
              src={imageUrl}
              alt="Profile"
              className="profile-image"
            />
          ) : (
            <div
              className="profile-image"
              style={{
                backgroundColor: "#f0f0f0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              No Image
            </div>
          )}
          <div className="inforow_div">
            <div className="inforow">
              <div className="membertitle">Name</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.name}</div>
            </div>

            <div className="inforow">
              <div className="membertitle">Email</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.email}</div>
            </div>

            <div className="inforow">
              <div className="membertitle">Phone</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.phone}</div>
            </div>

            <div className="inforow">
              <div className="membertitle">DOB</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.dob}</div>
            </div>

            <div className="inforow">
              <div className="membertitle">Gender</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.gender}</div>
            </div>

            <div className="inforow">
              <div className="membertitle">Cultural</div>
              <div className="colums">:</div>
              <div className="title-value">
                {memberData.cultural_background}
              </div>
            </div>

            <div className="inforow">
              <div className="membertitle">Belief</div>
              <div className="colums">:</div>
              <div className="title-value">{memberData.religious_belief}</div>
            </div>
          </div>
        </CCardBody>

        <CCardFooter className="profile-footer">
          {/* <CButton */}
          <div
            className="send-button"
            onClick={handleSendInterest}
            disabled={isRequestSent}
          >
            {isRequestSent ? "Interest Sent" : "Send Interest"}
            {/* </CButton> */}
          </div>
        </CCardFooter>
      </CCard>
    </div>
  );
};

export default MemberProfile;
